import { render, staticRenderFns } from "./index.vue?vue&type=template&id=284b5aef&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b5aef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284b5aef')) {
      api.createRecord('284b5aef', component.options)
    } else {
      api.reload('284b5aef', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=284b5aef&scoped=true", function () {
      api.rerender('284b5aef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/BeginnerCourse/index.vue"
export default component.exports